import { Controller, useFormContext } from 'react-hook-form'

import { FF2, TextInput, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const Address = () => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name="institutionContactInfo.address"
      control={control}
      rules={{ validate: Validators.required.field }}
      render={({ field }) => (
        <FF2
          required
          label="82. Address"
          field={field}
          input={(props) => <TextInput {...props} maxLength={100} data-qa="82. Address" />}
        />
      )}
    />
  )
}
